import {
  CodeOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  FormOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
  MailOutlined,
  SettingOutlined,
  PhoneOutlined,
  CalendarOutlined,
  ScanOutlined,
  ApiOutlined,
} from '@ant-design/icons';
import { UserShield } from '@insight-health-ai/roseate/icons';
import { useFeatureEntitlements } from '@frontegg/react';
import { useGetCurrentPractitioner } from 'src/hooks/settings';

export const useSuperAdminSideMenu = () => {
  const { isSuperAdmin } = useGetCurrentPractitioner();

  const { isEntitled: isFrontdeskModuleEntitled } =
    useFeatureEntitlements('frontdesk');

  if (!isSuperAdmin) {
    return [];
  }

  return [
    {
      path: '/superadmin',
      title: 'Super Admin',
      icon: <UserShield />,
      submenu: [
        {
          path: '/ai',
          title: 'AI',
          icon: <CodeOutlined />,
        },
        {
          path: '/agents',
          title: 'Agents',
          icon: <UserOutlined />,
        },
        {
          path: '/csvupload',
          title: 'CSV Upload',
          icon: <FileTextOutlined />,
        },
        {
          path: '/sr-upload',
          title: 'Service Request',
          icon: <MailOutlined />,
        },

        {
          path: '/formconditions',
          title: 'Form Conditions',
          icon: <FormOutlined />,
        },
        {
          path: '/templates',
          title: 'Templates',
          icon: <FileTextOutlined />,
        },
        {
          path: '/superadmin/notification-templates',
          title: 'Notification templates',
          icon: <MailOutlined />,
        },
        {
          path: '/superadmin/officepracticum',
          title: 'Office Practicum',
          icon: (
            <img
              src="https://images.insighthealth.ai/office-practicum/logo.svg"
              alt="Office Practicum Logo"
              width={20}
              height={20}
              className="mr-[-4px]"
            />
          ),
        },
        {
          path: '/superadmin/ehr-appointment-type-mapping',
          title: 'EHR Appointment Mapping',
          icon: <SettingOutlined />,
        },
        {
          path: '/superadmin/fax',
          title: 'Fax',
          icon: <ScanOutlined />,
        },
        {
          path: '/superadmin/ehr-integrations',
          title: 'EHR Integrations',
          icon: <ApiOutlined />,
        },
        {
          path: '/superadmin/data-retention',
          title: 'Data Retention',
          icon: <DatabaseOutlined />,
        },
        {
          path: '/superadmin/magicflow',
          title: 'Magicflow',
          icon: <SettingOutlined />,
        },
        {
          path: '/superadmin/scheduling-rules',
          title: 'Scheduling Rules',
          icon: <CalendarOutlined />,
        },
        ...(isFrontdeskModuleEntitled
          ? [
              {
                path: '/frontdesk/appointments',
                title: 'Frontdesk Appointments',
                icon: <PhoneOutlined />,
              },
              {
                path: '/frontdesk/appointment-slots',
                title: 'Frontdesk Appointment Slots',
                icon: <CalendarOutlined />,
              },
            ]
          : []),
      ],
    },
    {
      title: 'Care AI',
      path: '',
      icon: <SafetyCertificateOutlined />,
    },
  ];
};
